import axios from 'axios'

/**
 * Fetch AdSense page eligibility and configuration from the backend.
 * @param {string} path - Current page path
 * @param {string} host - Current page host
 */
export async function fetchAdSenseStatus(path, host) {
  try {
    const response = await axios.get('/adsense/public/eligibility', {
      params: {
        path,
        host
      }
    })
    return response.data || {
      enabled: false,
      pageEligible: false,
      adConfig: null
    }
  } catch (error) {
    console.error('Error fetching AdSense status:', error)
    return {
      enabled: false,
      pageEligible: false,
      adConfig: null
    }
  }
}

/**
 * Initialize AdSense on component mount
 * Safe wrapper for window.adsbygoogle.push()
 */
export function initializeAdSense() {
  try {
    if (typeof window !== 'undefined' && window.adsbygoogle) {
      window.adsbygoogle.push({})
      return true
    }
  } catch (error) {
    // silent failure
  }
  return false
}

/**
 * Check if AdSense script is loaded
 * @returns {boolean} - True if adsbygoogle is available
 */
export function isAdSenseLoaded() {
  return typeof window !== 'undefined' && !!window.adsbygoogle
}

/**
 * Insert AdSense script into the document head from a script tag string.
 * Prevents duplicate injections and logs operations.
 */
export function insertAdSenseScript(scriptHtml) {
  if (typeof document === 'undefined' || !scriptHtml) {
    console.warn('[AdSense] Cannot insert script: document not available or scriptHtml empty')
    return false
  }

  // Check if script already exists
  const existingScript = document.getElementById('adsense-script')
  if (existingScript) {
    console.log('[AdSense] Script already exists, skipping injection')
    return true
  }

  // Check for any existing AdSense scripts
  const existingAdSenseScripts = document.querySelectorAll('script[src*="googlesyndication.com"]')
  if (existingAdSenseScripts.length > 0) {
    console.log('[AdSense] Existing AdSense script found, skipping injection')
    return true
  }

  try {
    console.log('[AdSense] Injecting AdSense script dynamically')

    const wrapper = document.createElement('div')
    wrapper.innerHTML = scriptHtml.trim()
    const incomingScript = wrapper.querySelector('script')
    if (!incomingScript) {
      console.error('[AdSense] No script tag found in provided HTML')
      return false
    }

    const script = document.createElement('script')
    script.id = 'adsense-script'

    if (incomingScript.src) {
      script.src = incomingScript.src
      script.async = incomingScript.async !== false
      script.crossOrigin = incomingScript.crossOrigin || 'anonymous'
    }

    Array.from(incomingScript.attributes).forEach((attr) => {
      if (attr.name !== 'src' && attr.name !== 'async') {
        script.setAttribute(attr.name, attr.value)
      }
    })

    if (incomingScript.textContent) {
      script.textContent = incomingScript.textContent
    }

    document.head.appendChild(script)
    console.log('[AdSense] Script injected successfully')
    return true
  } catch (error) {
    console.error('[AdSense] Failed to inject script:', error)
    return false
  }
}
